import React from 'react';
import './FoodSource.styles.scss';

function FoodSource({ data }) {
    return (
        <div className="food-source">
            {data.map((item, inx) =>  (
                <div key={inx} className="food-source__item">
                    <div className="food-source__percents" style={{ backgroundColor: `${item.color}` }}>{item.value}%</div>
                    <div className="food-source__name">{item.name}</div>
                </div>
            ))}
            <div className="food-source__wrap food-source__wrap--blue">
                <div className="food-source__title">of those <br/>AFH <br/>events:</div>
                {data[2].events.map((item, inx) => (
                    <div key={inx} className="food-source__item food-source__item--small">
                        <div className="food-source__percents" style={{ backgroundColor: `${item.color}` }}>{item.value}%</div>
                        <div className="food-source__name">{item.name}</div>
                    </div>
                ))}
            </div>
            <div className="food-source__wrap food-source__wrap--green">
                <div className="food-source__title">of those <br/>restaurant <br/>events:</div>
                {data[2].events[2].events.map((item, inx) => (
                    <div key={inx} className="food-source__item food-source__item--small">
                        <div className="food-source__percents" style={{ backgroundColor: `${item.color}` }}>{item.value}%</div>
                        <div className="food-source__name">{item.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default FoodSource;